'use client'

import { useTranslate } from '@repo/shared/hooks'
import {
  Button,
  CenterBox,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography,
} from '@repo/ui/components'
import Image from 'next/image'

interface IQuickKycExitDialogProps {
  isOpen: boolean
  onClose: () => void
  onLogout: () => void
  onReturn: () => void
}

export const QuickKycExitDialog = ({
  isOpen,
  onClose,
  onLogout,
  onReturn,
}: IQuickKycExitDialogProps) => {
  const { t } = useTranslate()

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='sm:max-w-[450px]'>
        <DialogHeader className='flex flex-col gap-2xs'>
          <CenterBox>
            <Image
              src='/images/kyc-dismiss-alert.webp'
              alt='kyc dismiss alert'
              width={80}
              height={80}
            />
          </CenterBox>
          <DialogTitle className='text-right leading-xl mb-md'>
            <Typography size='md' color='text-neutral-surface-100'>
              {t('quickKyc_exit_dialog_title')}
            </Typography>
          </DialogTitle>
        </DialogHeader>

        <DialogFooter className='flex flex-col gap-md'>
          <Button onClick={onLogout} width='full' color='negative'>
            {t('quickKyc_logout')}
          </Button>

          <Button
            onClick={onReturn}
            width='full'
            variant='ghost'
            color='neutral'
          >
            {t('quickKyc_return_verify')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
